import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import moment from "moment";
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../app.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-upcoming-visits-box',
  templateUrl: './upcoming-visits-box.component.html',
  styleUrls: ['./upcoming-visits-box.component.css']
})
export class UpcomingVisitsBoxComponent implements OnInit {

  @Input() Visits: any;


  CounterText = "";
  IsSessionInTime = false;
  roles: any[] = [];

  constructor(
    private translate: TranslateService,
    private http: HttpClient,
    private activeRoute: ActivatedRoute,
    public app: AppService,
    public appComp: AppComponent,
    private router: Router,
    private toaster: ToastrService,
  ) { }

  ngOnInit() {



    this.Visits && this.Visits.length && this.loopSessionTimeChange();
  }

  ngOnChanges(): void {
    this.Visits && this.Visits.length && this.loopSessionTimeChange();
  }

  public loopSessionTimeChange() {
    if (!this.Visits) return
    let slotTime = moment(this.Visits[0].visitDate)


    let now = new Date();

    let diffMinutes = slotTime.diff(now, "minutes");

    // if (Math.abs(diffMinutes) < 15) {
    this.IsSessionInTime = true;
    // this.CounterText = this._getCounterText(diffMinutes);
    this.CounterText = this._getCounterText(diffMinutes);
    // } else {
    //   this.IsSessionInTime = false;
    // }
    if(this.router.url.includes("/video-call")){
      this.IsSessionInTime = false;
    }
  }

  private _getCounterText(minutesDifference) {

    let absoluteMintes = Math.abs(minutesDifference);
    let fullName;
    let currentLang = this.translate.currentLang;


    // role === ClaimRoles.User
    if (this.app.isPatient) {
      fullName = this?.Visits[0]?.hcp?.name;
    } else if (this.app.isDoctor) {
      fullName = this?.Visits[0]?.patient?.name;
    }

    if (minutesDifference > 0) {
      return `${currentLang == "ar" ? "الجلسة مع " : "Your Session With "
        } ${fullName} ${currentLang == "ar" ? "سوف تبدأ بعد" : "Will Start After"
        } ${absoluteMintes || 1} 
        ${minutesDifference <= 2
          ? currentLang == "ar"
            ? "دقيقة"
            : "Minute"
          : currentLang == "ar"
            ? "دقائق"
            : "Minutes"
        }`;
    } else if (minutesDifference <= 0) {
      return `${currentLang == "ar" ? "الجلسة مع" : "Your Session With"
        } ${fullName} ${currentLang == "ar" ? "بدأت" : "Started"
        } ${absoluteMintes || 1} ${minutesDifference <= 2
          ? currentLang == "ar"
            ? "دقيقة"
            : "Minute"
          : currentLang == "ar"
            ? "Minutes"
            : "دقائق"
        } ${currentLang == "ar" ? "قبل" : " Ago"}`;
    }
  }

  markSlotCompleted(visitId) {
    // this.calendarService.MarkBookingCompleted(this.Visits[0].id).subscribe(res => {
    //   this.IsSessionInTime = false;
    //   this.Visits.status = { ...this.Visits, status: 5 };
    // });
    // /api/hcp/visit/complete/{id}
    this.http.post<any>(environment.baseUrl + "hcp/visit/complete/" + visitId, null)
      .subscribe(res => {
        if (res.errorCode == 0) {

          if(this.app.getUserLanguage() == 'en'){
            this.toaster.info("Session Marked As Completed")
          } else {
            this.toaster.info("تم وضع علامة على الجلسة على أنها مكتملة")
          }
          setTimeout(() => {
            location.reload();
          }, 500);
        } else if(res.errorCode != 0){
          this.toaster.error(res.errorMessage)
        }
      })
  }

  // checkStatus() { 
  //   if (this.Slot && this.Slot.length && this.Slot[0]['status'] == 4) {
  //     this.http.post<any>(environment.baseUrl + "Coach/Appointment/startSession/" + this.Slot.id, null)
  //     .subscribe(res => {})
  //   }
  // }

  startSessionById(visitId: number, hcpId, userId, status) {
    if (this.app.isDoctor) {
      if (status == 4) {
        this.http.post<any>(environment.baseUrl + "hcp/visit/startSession/" + visitId, null)
          .subscribe(res => {

            if(this.app.getUserLanguage() == 'en'){
              this.toaster.info("Session Started")
            } else {
              this.toaster.info("تم بدأ الجلسة")
            }
            setTimeout(() => {
              this.router.navigate(['/' + this?.app?.languageCode + '/video-call'], {
                queryParams: {
                  'visitId': visitId,
                  'hcpId': hcpId,
                  'userId': userId,
                }
              });
            }, 1500);
          })
      } else {
        this.router.navigate(['/' + this?.app?.languageCode + '/video-call'], {
          queryParams: {
            'visitId': visitId,
            'hcpId': hcpId,
            'userId': userId,
          }
        });
      }
    } else if (this.app.isPatient) {
      if (status == 7) {
        this.router.navigate(['/' + this?.app?.languageCode + '/video-call'], {
          queryParams: {
            'visitId': visitId,
            'hcpId': hcpId,
            'userId': userId,
          }
        });
      } else {
        if(this.app.getUserLanguage() == 'en'){
          this.toaster.info("Your HCP has not yet started the session")
        } else {
          this.toaster.info("لم يتم بدأ الجلسة من قبل الطبيب")
        }
      }
    }
    this.appComp.upComingVisits$ = undefined

  }

}
